import React from "react";
import {ConfigProvider, Input, Tooltip} from "antd";

export const ProductPaymentSection = ({
    priceSectionLines = [],
    formValues,
    onFieldChange,
    totalPrice,
    shouldShowTotalPrice = true
}) => {
    return (
        <ConfigProvider direction="rtl">
            <div className="admin-edit-order-modal-price-section">
                <div className="admin-edit-order-modal-price-edit-section">
                    {priceSectionLines.map(({title, key, suffix, disabled, hideIfEmpty, format}) => {
                        if (hideIfEmpty && !formValues[key]) {
                            return null;
                        }

                        const value = format ? format(formValues[key]) : formValues[key];

                        const inputElement = (
                            <Input
                                className="admin-edit-order-modal-price-edit-section-input"
                                value={value ?? 0}
                                disabled={!!disabled}
                                onChange={({target}) => onFieldChange(key, target.value)}
                            />
                        );
                        return (
                            <div className="admin-edit-order-modal-price-line" key={key}>
                                <span className="admin-edit-order-modal-price-line-title">{title}</span>
                                <div className="admin-edit-order-modal-price-line-container">
                                    {isNaN(Number(formValues[key] ?? 0)) ? (
                                        <span className="admin-edit-order-modal-price-line-error">יש להכניס מספר!</span>
                                    ) : null}
                                    {disabled ? <Tooltip title={disabled}>{inputElement}</Tooltip> : inputElement}

                                    <span className="pricing-description">{suffix ?? "₪ כולל מע״מ"}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {!!shouldShowTotalPrice && (
                    <div className="admin-edit-order-modal-price-total-line">
                        <span>סה״כ</span>
                        <span>₪{totalPrice.toLocaleString()} כולל מע״מ</span>
                    </div>
                )}
            </div>
        </ConfigProvider>
    );
};
